import { createAction } from '@reduxjs/toolkit';

export const CHANGE_CONVERSATION_NAME_ACTION_TYPE = 'saga/changeConversationName';
export const changeConversationNameAction = createAction(CHANGE_CONVERSATION_NAME_ACTION_TYPE);
